import React from 'react'
import PropTypes from 'prop-types'
import fetch from 'isomorphic-unfetch'
import debounce from 'lodash/debounce'

import CONFIG from 'isomorphic-config'

function getEndPoint(searchKey) {
  switch (searchKey) {
    case 'startLocation':
      return 'packagesOrigin'
    case 'endLocation':
      return 'packagesDestination'
    case 'rcLocation':
      return 'cars'
    default:
      return 'packagesDestination'
  }
}

class FetchTypeAhead extends React.Component {
  static initialState = { loading: false, error: null, items: [] }

  mounted = false

  fetch = debounce(() => {
    if (!this.mounted) {
      return
    }
    const { searchValue, searchKey, typeAheadEndpoint } = this.props

    let endpoint = typeAheadEndpoint
    if (typeAheadEndpoint === 'packages') {
      endpoint = getEndPoint(searchKey)
    }

    const locationConfig = CONFIG.client.typeahead.location
    const isRCSearchEndPoint = endpoint === 'cars'
    const parsedURLSuffix = isRCSearchEndPoint
      ? ''
      : locationConfig.suffix[typeAheadEndpoint]
    const parseURLSuffixQS = isRCSearchEndPoint
      ? locationConfig.querystring.cars
      : ''
    const url = `${locationConfig[endpoint]}${searchValue}${parsedURLSuffix}${parseURLSuffixQS}`

    if (searchValue.trim()) {
      fetch(url)
        .then(res => res.json())
        .then(({ searchItems = [] }) => {
          if (this.mounted && searchItems) {
            this.props.onLoaded()
            this.setState({ loading: false, items: searchItems })
          }
        })
        .catch(error => {
          if (this.mounted) {
            this.props.onLoaded()
            this.setState({ loading: false, error })
          }
        })
    }
  }, 300)

  constructor(props) {
    super(props)
    this.state = FetchTypeAhead.initialState
  }

  componentDidMount() {
    this.mounted = true
    this.prepareFetch()
    this.fetch()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.searchValue !== this.props.searchValue ||
      prevProps.searchKey !== this.props.searchKey
    ) {
      this.prepareFetch()
      this.fetch()
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  reset(overrides) {
    this.setState({ ...FetchTypeAhead.initialState, ...overrides })
  }

  prepareFetch() {
    this.reset({ loading: false })
  }

  render() {
    return this.props.render(this.state)
  }
}

FetchTypeAhead.propTypes = {
  searchValue: PropTypes.string.isRequired,
  searchKey: PropTypes.string.isRequired,
  onLoaded: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  typeAheadEndpoint: PropTypes.string
}

export default FetchTypeAhead
